export const DefaultShadows = {
  sm: '0 0.2rem 0.4rem rgba(0, 0, 0, 0.1)',
  md: '0 0.4rem 1.2rem rgba(0, 0, 0, 0.1)',
  lg: '0 0.4rem 1.6rem rgba(0, 0, 0, 0.1)',
  xl: '0 0.4rem 2.4rem rgba(0, 0, 0, 0.15)',
}

export type Shadows = typeof DefaultShadows
